import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/web/src/app/[lang]/(referral)/components/referral-landing-page.tsx");
